import React from 'react';
import { FormattedMessage } from 'react-intl';
import { WarningIcon } from '../../../assets/icons/WarningIcon';
import styles from './styles.module.scss';

export const ErrorMessage = ({ message }) => (
  <div className={styles.errorMessage}>
    <WarningIcon />

    <FormattedMessage id={message} />
  </div>
);
